import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { BaseService } from '../../core';
import { FeedbackResponse } from './response/feedback-register.response';
import { FeedbackTemplateResponse } from './response/feedback-template.response';
import { FeedbackRegisterRequest } from './request/feedback-register.request';

@Injectable({ providedIn: 'root' })
export class FeedbackService extends BaseService {
  private feedbackEndpoint = `${environment.urlEdducaImobApi}EdducaImobCore/Feedback/`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Lista feedbacks RECEBIDOS pelo usuário
   */
  listarFeedbacksRecebidos(usuarioId: number): Observable<FeedbackResponse[]> {
    return this.http
      .get<FeedbackResponse[]>(`${this.feedbackEndpoint}ListarFeedbacks/${usuarioId}`, {
        headers: this.getHeader(true),
      });
  }

  /**
   * Lista feedbacks ENVIADOS pelo usuário
   */
  listarFeedbacksEnviados(usuarioId: number): Observable<FeedbackResponse[]> {
    return this.http
      .get<FeedbackResponse[]>(`${this.feedbackEndpoint}ListarFeedbacksEnviados/${usuarioId}`, {
        headers: this.getHeader(true),
      });
  }

  /**
   * Lista TODOS os feedbacks de uma imobiliária (para ADM_SISTEMA e PARCEIRO)
   */
  listarFeedbacksImobiliaria(imobiliariaId: number): Observable<FeedbackResponse[]> {
    return this.http
      .get<FeedbackResponse[]>(`${this.feedbackEndpoint}ListarFeedbacksImobiliaria/${imobiliariaId}`, {
        headers: this.getHeader(true),
      });
  }

  /**
   * @deprecated Use listarFeedbacksRecebidos
   */
  listarFeedbacks(usuarioId: number): Observable<FeedbackResponse[]> {
    return this.listarFeedbacksRecebidos(usuarioId);
  }

  cadastrar(request: FeedbackRegisterRequest): Observable<FeedbackResponse> {
    return this.http
      .post<FeedbackResponse>(`${this.feedbackEndpoint}Cadastrar`, request, {
        headers: this.getHeader(true),
      });
  }

  /**
   * Lista templates ativos de feedback (modelos pré-definidos)
   */
  listarTemplates(): Observable<FeedbackTemplateResponse[]> {
    return this.http
      .get<FeedbackTemplateResponse[]>(`${this.feedbackEndpoint}ListarTemplates`, {
        headers: this.getHeader(false),
      });
  }
}
